import { Shield, Target, Gauge, TrendingDown, CalendarX2, Lock, Activity, Banknote, LineChart, BellOff } from "lucide-react";
import { useI18n } from "../../i18n";

const ICONS = [Shield, TrendingDown, Target, Gauge, Activity, CalendarX2, Lock, BellOff, LineChart];

export default function Features() {
  const { t } = useI18n();
  return (
    <section id="features" className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="chip"><Banknote className="w-3 h-3 text-[color:var(--gold)]" /> {t("features_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            {t("features_h1_a")} <span className="text-[color:var(--gold)]">{t("features_h1_b")}</span>
          </h2>
          <p className="text-[color:var(--ink-dim)] mt-4 text-sm sm:text-base leading-relaxed">{t("features_sub")}</p>
        </div>

        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {ICONS.map((Icon, i) => (
            <div key={i} data-testid={`feature-${i}`} className="panel p-5 sm:p-6 group transition-all hover:-translate-y-0.5">
              <div className="w-10 h-10 rounded-xl grid place-items-center border border-[#23232a] bg-[rgba(231,180,59,.05)] group-hover:border-[color:var(--gold)] transition-colors">
                <Icon className="w-4.5 h-4.5 text-[color:var(--gold)]" />
              </div>
              <h3 className="font-display font-bold text-base sm:text-[17px] mt-4">{t(`feat${i + 1}_title`)}</h3>
              <p className="text-[13px] sm:text-[13.5px] text-[color:var(--ink-dim)] mt-2 leading-relaxed">{t(`feat${i + 1}_desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
